// Promo Box
$('.promo-box-name').txtTruncate({
	end: '...',
	lines: 1,
});

$('.promo-box-description').txtTruncate({
	end: '...',
	lines: 2,
});



// WEBPACK FOOTER //
// ./scripts/util/ellipsis.js